export default __webpack_public_path__ + "images/08745949f3f034d5aeecabd027e56b60-london_desktop.webp";